import {ICompany, IExportTemplate, IImportHrFile, IMessage, IRouteDefinition, IRuleset, ISystem} from "../../index";
import {IDropdownButton} from "../button";
import {buildRulesetActions} from "../ruleset/read/rulesetActions";
import {buildMessageFlowActions} from "../messages/messageflowActions";
import {buildSystemAccessActions} from "../systemaccess/systemaccessActions";
import {buildSyncTemplateActions} from "../export-template/syncTemplateActions";
import {buildCustomerSetupActions} from "../customer/customerSetupActions";
import {buildImportHistoryActions} from "../import/importHistoryActions";

/** Hybrid command bar: quick actions stay visible; the rest sit behind "Mer". */
export interface IPageShellHeaderActions {
    quick: IDropdownButton[]
    more: IDropdownButton[]
}

export const EMPTY_HEADER_ACTIONS: IPageShellHeaderActions = {quick: [], more: []};

/** Detail shells that own edit (and related) commands in the tab-row action bar. */
export function usesPageShellHeaderActionBar(routeDef: IRouteDefinition): boolean {
    switch (routeDef.content) {
        case 'component/ruleset/read/details':
        case 'component/messages/details':
        case 'component/systemaccess/details':
        case 'component/export-template/details':
        case 'component/customer/general/details':
        case 'component/import/details':
            return true;
        default:
            return false;
    }
}

/**
 * Object-level actions for the page-shell tab row, keyed by the shell's content component so they
 * stay visible on every tab instead of living in one tab's card header.
 */
export function buildPageShellHeaderActions(routeDef: IRouteDefinition, data: unknown): IPageShellHeaderActions {
    if (!data) {
        return EMPTY_HEADER_ACTIONS;
    }
    switch (routeDef.content) {
        case 'component/ruleset/read/details':
            return buildRulesetActions(data as IRuleset);
        case 'component/messages/details':
            return buildMessageFlowActions(data as IMessage);
        case 'component/systemaccess/details':
            return buildSystemAccessActions(data as ISystem, routeDef);
        case 'component/export-template/details':
            return buildSyncTemplateActions(data as IExportTemplate);
        case 'component/customer/general/details':
            return buildCustomerSetupActions(data as ICompany);
        case 'component/import/details':
            return buildImportHistoryActions(data as IImportHrFile);
        default:
            return EMPTY_HEADER_ACTIONS;
    }
}
